import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React from 'react';
import { FlatList, Platform } from 'react-native';
import styled from 'styled-components/native';
import { DiscoverParamList } from '../navigation/DiscoverNavigator';
import { ScreenComponentProps } from '../screens/study/screen-components/ScreenComponentPlugin';
import Chip from './Chip';

const StyledContainer = styled.View`
  width: 100%;
`;

// const StyledItemContainer = styled.View`
//   ${Platform.OS === 'web' ? 'margin-bottom: 6px' : ''}
// `;

const StyledSeparator = styled.View`
  width: 12px;
`;

export interface CategoryHorizontalListItem {
  label?: string;
  color?: string;
  screenId?: number;
}

export interface CategoryHorizontalListProps {
  categories: CategoryHorizontalListItem[];
  onSelect?: (category: CategoryHorizontalListItem) => void;
}

const CategoryHorizontalList: React.FC<
  ScreenComponentProps<CategoryHorizontalListProps>
> = ({ categories = [{ label: 'Placeholder' }], onSelect }) => {
  const navigation = useNavigation<StackNavigationProp<DiscoverParamList>>();
  const colors = ['#E6E3FE', '#CCF5FF', '#FFBACF', '#B3EDDF'];
  return (
    <StyledContainer>
      <FlatList
        keyExtractor={(_, index) => index.toString()}
        horizontal
        overScrollMode='never'
        showsHorizontalScrollIndicator={Platform.OS === 'web'}
        data={categories}
        initialNumToRender={10}
        maxToRenderPerBatch={10}
        ItemSeparatorComponent={() => <StyledSeparator />}
        renderItem={listItem => {
          const item = listItem.item;
          return (
            <Chip
              // color={colors[listItem.index % colors.length]}
              color={item.color ?? colors[listItem.index % colors.length]}
              onPress={() => {
                if (onSelect) {
                  onSelect(item);
                } else if (item.screenId) {
                  navigation.navigate('DynamicScreen', {
                    screenId: item.screenId
                  });
                }
              }}
            >
              {item.label || ''}
            </Chip>
          );
        }}
      />
    </StyledContainer>
  );
};

export default CategoryHorizontalList;
